{
  "schemaVersion": 1,
  "assets": {
    "win": {
      "path": "/game/ui/results/win-atlas.svg",
      "frames": [
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg",
        "/game/ui/results/win-atlas.svg"
      ],
      "frameRects": [
        {
          "x": 0,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 323,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 323,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 969,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 1292,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 1615,
          "y": 0,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 151,
          "width": 323,
          "height": 151
        },
        {
          "x": 323,
          "y": 151,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 151,
          "width": 323,
          "height": 151
        },
        {
          "x": 969,
          "y": 151,
          "width": 323,
          "height": 151
        },
        {
          "x": 1292,
          "y": 151,
          "width": 323,
          "height": 151
        },
        {
          "x": 1615,
          "y": 151,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 302,
          "width": 323,
          "height": 151
        },
        {
          "x": 323,
          "y": 302,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 302,
          "width": 323,
          "height": 151
        },
        {
          "x": 969,
          "y": 302,
          "width": 323,
          "height": 151
        },
        {
          "x": 1292,
          "y": 302,
          "width": 323,
          "height": 151
        },
        {
          "x": 1615,
          "y": 302,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 453,
          "width": 323,
          "height": 151
        },
        {
          "x": 323,
          "y": 453,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 453,
          "width": 323,
          "height": 151
        },
        {
          "x": 969,
          "y": 453,
          "width": 323,
          "height": 151
        },
        {
          "x": 1292,
          "y": 453,
          "width": 323,
          "height": 151
        },
        {
          "x": 1615,
          "y": 453,
          "width": 323,
          "height": 151
        },
        {
          "x": 0,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 323,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        },
        {
          "x": 646,
          "y": 604,
          "width": 323,
          "height": 151
        }
      ],
      "width": 323,
      "height": 151,
      "anchor": {
        "x": 151,
        "y": 201
      },
      "atlasWidth": 1938,
      "atlasHeight": 755,
      "uniqueFrames": 27,
      "sha256": "473e274b97e8dbb3cadd5d0fd24fec437f04f22ba6290d13831d47aebcb9f0b2",
      "bytes": 118318,
      "sourceCharacterId": 155,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Source ShapeRecord paths/gradients/MATRIX/alpha/depth/ShowFrame order; identical scenes and ShapeRecords share an SVG atlas. Portuguese depth1 title omitted explicitly, original WIN/LOSE and sparkle artwork retained without repaint.",
      "omittedTitleCharacterId": 142,
      "titleOpacity": [
        0.19921875,
        0.6015625,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "titleRects": [
        {
          "x": -150.6,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -140.85,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -137.6,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -127.2,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        },
        {
          "x": -131.1,
          "y": -195.5,
          "width": 180.0,
          "height": 66.0
        }
      ],
      "titleLanguage": "Portuguese; not presented as original Chinese artwork",
      "candidateConfidence": "Later overseas candidate, unverified2009 chronology; ordinary Chinese overlay must use plain current typography.",
      "symbol": "asset.game.winAsset",
      "loop": false,
      "frameRate": 25,
      "sourceFileFrameRate": 24.0,
      "sourceRootFrameCount": 70,
      "rootStopAtSourceFrame": 70,
      "rootSourceFrames": [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        70,
        70,
        70,
        70,
        70
      ],
      "position": {
        "x": 500,
        "y": 360
      },
      "durationMs": 3000,
      "nestedTimelinesContinueAfterRootStop": true,
      "frameScripts": [
        {
          "sourceFrame": 70,
          "method": "asset.game.frame70",
          "methodIndex": 514,
          "verifiedStopOnly": true,
          "bytecodeHex": "d0305dc5014fc5010047"
        }
      ]
    },
    "loss": {
      "path": "/game/ui/results/loss-atlas.svg",
      "frames": [
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg",
        "/game/ui/results/loss-atlas.svg"
      ],
      "frameRects": [
        {
          "x": 0,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 352,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 704,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 1056,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 1760,
          "y": 0,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 352,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 704,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1056,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 1760,
          "y": 191,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 382,
          "width": 352,
          "height": 191
        },
        {
          "x": 352,
          "y": 382,
          "width": 352,
          "height": 191
        },
        {
          "x": 704,
          "y": 382,
          "width": 352,
          "height": 191
        },
        {
          "x": 1056,
          "y": 382,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 382,
          "width": 352,
          "height": 191
        },
        {
          "x": 1760,
          "y": 382,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 573,
          "width": 352,
          "height": 191
        },
        {
          "x": 352,
          "y": 573,
          "width": 352,
          "height": 191
        },
        {
          "x": 704,
          "y": 573,
          "width": 352,
          "height": 191
        },
        {
          "x": 1056,
          "y": 573,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 573,
          "width": 352,
          "height": 191
        },
        {
          "x": 1760,
          "y": 573,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 764,
          "width": 352,
          "height": 191
        },
        {
          "x": 352,
          "y": 764,
          "width": 352,
          "height": 191
        },
        {
          "x": 704,
          "y": 764,
          "width": 352,
          "height": 191
        },
        {
          "x": 1056,
          "y": 764,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 764,
          "width": 352,
          "height": 191
        },
        {
          "x": 1760,
          "y": 764,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 955,
          "width": 352,
          "height": 191
        },
        {
          "x": 352,
          "y": 955,
          "width": 352,
          "height": 191
        },
        {
          "x": 704,
          "y": 955,
          "width": 352,
          "height": 191
        },
        {
          "x": 1056,
          "y": 955,
          "width": 352,
          "height": 191
        },
        {
          "x": 1408,
          "y": 955,
          "width": 352,
          "height": 191
        },
        {
          "x": 1760,
          "y": 955,
          "width": 352,
          "height": 191
        },
        {
          "x": 0,
          "y": 1146,
          "width": 352,
          "height": 191
        }
      ],
      "width": 352,
      "height": 191,
      "anchor": {
        "x": 156,
        "y": 229
      },
      "atlasWidth": 2112,
      "atlasHeight": 1337,
      "uniqueFrames": 37,
      "sha256": "e4c18e3c7b3bd06c5903ffd5218805a9592dd29e5a2663a588bc40f0397786ac",
      "bytes": 111745,
      "sourceCharacterId": 167,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Source ShapeRecord paths/gradients/MATRIX/alpha/depth/ShowFrame order; identical scenes and ShapeRecords share an SVG atlas. Portuguese depth1 title omitted explicitly, original WIN/LOSE and sparkle artwork retained without repaint.",
      "omittedTitleCharacterId": 158,
      "titleOpacity": [
        0.19921875,
        0.6015625,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      "titleRects": [
        {
          "x": -155.25,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -145.5,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -142.25,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -131.85,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        },
        {
          "x": -135.75,
          "y": -196.95,
          "width": 207.0,
          "height": 57.0
        }
      ],
      "titleLanguage": "Portuguese; not presented as original Chinese artwork",
      "candidateConfidence": "Later overseas candidate, unverified2009 chronology; ordinary Chinese overlay must use plain current typography.",
      "symbol": "asset.game.lostAsset",
      "loop": false,
      "frameRate": 25,
      "sourceFileFrameRate": 24.0,
      "sourceRootFrameCount": 70,
      "rootStopAtSourceFrame": 70,
      "rootSourceFrames": [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        70,
        70,
        70,
        70,
        70
      ],
      "position": {
        "x": 500,
        "y": 360
      },
      "durationMs": 3000,
      "nestedTimelinesContinueAfterRootStop": true,
      "frameScripts": [
        {
          "sourceFrame": 70,
          "method": "asset.game.frame70",
          "methodIndex": 484,
          "verifiedStopOnly": true,
          "bytecodeHex": "d0305dc5014fc5010047"
        }
      ]
    }
  },
  "sourceRules": {
    "position": {
      "x": 500,
      "y": 360
    },
    "frameRate": 25,
    "settlementDelayMs": 3000,
    "roomType": "ordinary room (GameOverAction roomType !=19)",
    "sequence": "Wait for moving objects/current player actions, show original Win/Lost movie, then call settlement after75 40ms action ticks.",
    "tie": "No ordinary tie symbol or special-room newTieAsset exists in the four available game SWFs. Keep the existing text; never fabricate artwork."
  },
  "evidence": "Exact archived later overseas candidate symbols and pinned original ActionScript rules. Neither the visuals nor their chronology are independently dated to2009."
}
